<h4 mat-dialog-title>
  {{ data.titleKey ? (data.titleKey | translate: data.params) : data.titleText }}
</h4>
<div mat-dialog-content innerHTML="{{ data.message || data.messageKey | translate: data.params }}"></div>
<div mat-dialog-actions align="end">
  <button class="btn btn-secondary mr-2" [mat-dialog-close]="false">
    {{ data.cancelText }}
  </button>
  <button class="btn btn-primary" [mat-dialog-close]="true" cdkFocusInitial>
    {{ data.confirmText }}
  </button>
</div>
